import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import PrettyCheckbox from 'pretty-checkbox-vue';
import Vuelidate from 'vuelidate';
import VueSweetalert2 from 'vue-sweetalert2';
import IdleVue from 'vue-idle';

import './lib/jquery/jquery';
import './lib/script';
import './lib/axios';
import App from './App.vue';
import router from './router';
import store from './store/store';

Vue.config.productionTip = false;
Vue.config.errorHandler = function(err) {
  console.trace();
  if (err && err.toString && err.toString().indexOf('503') !== -1) {
    console.log('Maintenance mode');
  } else {
    throw err;
  }
}

Vue.use(PrettyCheckbox);
Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(VueSweetalert2);
Vue.use(IdleVue, {
  eventEmitter: new Vue(),
  idleTime: 60000,
  events: ['mousemove', 'keydown', 'mousedown', 'touchstart', 'scroll']
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
